import React from "react";
import {Bar} from "react-chartjs-2";

import {
    Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend
} from "chart.js";
import ClipLoader from "react-spinners/ClipLoader";
import NoDataMessage from "../../../../../components/noDataMessage";
import LoadingBarChart from "../components/loadingBarChart";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const MilestonePotenzialChart = ({
                            data,
                            loading = true,
                            title = '',
                            mainBackground = 'rgb(58, 70, 169)',
                            secondaryBackground = '#ECEDF7'
                        }) => {
    const summeValues = data.map((item) => parseInt(item.summe, 10));
    const cleanMilestones = data.map((item) => item.milestone.replace(/^\d+\s*/, ""));

    const chartData = {
        labels: data.map(() => ""), // No labels in the chart itself
        datasets: [{
            label: "FP",
            data: summeValues,
            backgroundColor: mainBackground,
            borderColor: mainBackground,
            borderWidth: 1,
        },],
    };

    const options = {
        indexAxis: "y", // Horizontal bar chart
        responsive: true, maintainAspectRatio: false, plugins: {
            legend: {
                display: false,
            }, title: {
                display: title.length > 0, text: title,
            },
        }, scales: {
            x: {
                beginAtZero: true,
            }, y: {
                display: true,
            },
        }, elements: {
            bar: {
                barThickness: 30, // Adjust the height of the bars
            },
        },
    };

    return (loading ? (<LoadingBarChart />) : (
        <div style={{display: "flex", alignItems: "stretch", width: "100%"}}>
            {data.length === 0 ? (<NoDataMessage message="No data to display"/>) : (<>
                {/* Table for labels */}
                <div style={{width: "45%", zIndex: "1"}}>
                    <table style={{
                        width: "100%", borderCollapse: "collapse", fontSize: "15px", tableLayout: "fixed"
                    }}>
                        <thead>
                        <tr style={{borderBottom: "2px solid #ddd"}}>
                            <th style={{
                                textAlign: "left", fontWeight: "bold", padding: "6px", width: "2vw"
                            }}>#
                            </th>
                            <th style={{textAlign: "left", fontWeight: "bold", padding: "0"}}>Projekt-Fortschritt (Meilenstein)</th>
                            <th style={{
                                textAlign: "right", fontWeight: "bold", padding: "6px", width: "20%"
                            }}>BWS
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.map((item, index) => (<tr key={index} style={{borderBottom: "1px solid #ddd"}}>
                            <td style={{
                                textAlign: "left", padding: "6px", fontWeight: "bold"
                            }}>{index + 1}</td>
                            <td style={{
                                padding: "6px",
                                textAlign: "left",
                                height: "39px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            }}>{cleanMilestones[index]}</td>
                            <td style={{
                                padding: "6px",
                                textAlign: "right",
                                fontWeight: "bold",
                                backgroundColor: secondaryBackground
                            }}>{item.summe}</td>
                        </tr>))}
                        </tbody>
                    </table>
                </div>
                {/* Chart without labels */}
                <div style={{
                    width: "55%",
                    height: `${(data.length) * 42.5}px`,
                    paddingTop: "27px",
                    left: "-15px",
                    position: "relative",
                    zIndex: "0",
                }}>
                    <Bar data={chartData} options={options}/>
                </div>
            </>)}
        </div>));
};

export default MilestonePotenzialChart;
